import { ApplicationConfig, inject } from "@angular/core";
import { ApolloClient, InMemoryCache } from "@apollo/client/core";
import { APOLLO_OPTIONS } from "apollo-angular";
import { HttpLink } from "apollo-angular/http";
import { ROUTES_CONFIG } from "src/config/routes.config";

const uri = ROUTES_CONFIG.graphql; // <-- add the URL of the GraphQL server here
export function apolloOptionsFactory(): ApolloClient.Options {
  const httpLink = inject(HttpLink);
  return {
    link: httpLink.create({ uri }),
    cache: new InMemoryCache(),
  };
}

export const graphqlProvider: ApplicationConfig["providers"] = [
  {
    provide: APOLLO_OPTIONS,
    useFactory: apolloOptionsFactory,
  },
];
